import { render, staticRenderFns } from "./validadorDocumento.vue?vue&type=template&id=459bfc9c&scoped=true&"
import script from "./validadorDocumento.vue?vue&type=script&lang=js&"
export * from "./validadorDocumento.vue?vue&type=script&lang=js&"
import style0 from "./validadorDocumento.vue?vue&type=style&index=0&id=459bfc9c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459bfc9c",
  null
  
)

export default component.exports